var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDogTraining = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 23,
  fill: "#1B1F23",
  "aria-hidden": "true",
  viewBox: "0 0 32 23"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.503.096a1.48 1.48 0 0 0-1.049 0L9.132 2.49l1.441 1.6 5.406-2.046L26.427 6h-8.64a2 2 0 0 0-3.732 1 2 2 0 0 0 3.732 1h8.817l-10.019 3.929L6.055 8.11v.016L2.93 6.984 8.566 4.85l-1.44-1.6L.968 5.58c-1.3.493-1.29 2.352.015 2.83l5.07 1.855v11.352l5.073-.563a1 1 0 0 1 .517.08l3.192 1.419a3 3 0 0 0 2.437 0l3.193-1.42a1 1 0 0 1 .517-.08l5.072.564V10.371L30 8.824V14h2V7a1.48 1.48 0 0 0-.969-1.403zM8.055 19.383v-8.386l7.958 2.913c.34.124.712.12 1.05-.012l.493-.194 6.499-2.524v8.203l-2.852-.317a3 3 0 0 0-1.55.24l-3.192 1.42a1 1 0 0 1-.812 0l-3.193-1.42a3 3 0 0 0-1.55-.24z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M32.055 15v2h-2v-2z"
})));
export default SvgDogTraining;